module.exports = __webpack_public_path__ + "static/media/chevronRight.64020f08.svg";